<!-- 上传图片 基于 Vant UI -->
<template>
    <div class="uploader-box">
        <van-uploader v-model="fileList" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :after-read="afterRead" :max-count="max" />
    </div>
</template>
<script>
import { QiniuUpload } from "../utils/qiniuUpload";
import {
    mapGetters,
    mapActions,
} from 'vuex'

export default {
    name: "upload-vant",
    props: ['max', 'fileListData'],
    computed: {
        ...mapGetters(["userInfo"]),
    },
    watch: {
        fileListData() {
            console.log('this.fileListData---->', this.fileListData);
            if (this.fileListData.length > 0) {
                this.fileList = this.fileListData;
            }
        }
    },
    data() {
        return {
            qiniuInfo: {},
            uploaderMaxSize: {},
            fileList: [],
        };
    },
    created() {
        this.getQiniuData();
        console.log('this.fileListData---->', this.fileListData);
    },
    methods: {
        
        _onOversize(file) {
            console.log('file---->', file);
            this.ToastManager('图片大小不能超过：' + (this.uploaderMaxSize.imageMaxSize / 1024) + 'M');
        },
        
        // 图片选择回调
        afterRead(file) {
            file.status = 'uploading';
            file.message = '上传中...';
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_QINIUKODO) {
                QiniuUpload(this.qiniuInfo, file)
                    .then((res) => {
                        let img_src = this.qiniuInfo.domain + res.key;
                        file.status = 'success';
                        file.message = '成功';
                        file.img_src = img_src;
                        this.$emit('callback', this.fileList)
                    });
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_ALIOSS) {
                this._onUploadImageToAliOss(file);
            }
            if (this.IMAGES_DRIVER == this.Constants.DRIVER_TENCENTCOS) {

            }
        },
        // 获取七牛云配置
        async getQiniuData() {
            let url = this.API.qiniuToken;
            let params = {};
            let result = await this.$post(url, params);
            this.qiniuInfo = result;
            this.uploaderMaxSize = result.uploaderMaxSize;
        },
        // 上传阿里云
        async _onUploadImageToAliOss(file) {
            let url = this.API.uploadToAliOss;
            let params = {
                file: file.file,
                uid: this.userInfo.id,
            };
            let result = await this.$uploadFormData(url, params);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                file.status = 'success';
                file.message = '成功';
                file.img_src = result.url;
                this.$emit('callback', this.fileList);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.uploader-box {}
</style>